import { isWithinInterval } from "date-fns";
import DateIntervalStrategy from "../DateIntervalStrategy";
import { getChartName } from "../../helpers/UtilityHelper";

export class RVPPickupPerformance extends DateIntervalStrategy {

    dataList = [];

    constructor(queryParams, _api) {
        super(queryParams.groupOn, queryParams.fromDate, queryParams.toDate)
        this.groupOn = queryParams.groupOn || 'DOD';
        const keyLists = Object.keys(_api.getState().courierPerformanceApi.queries).filter(key => key.includes('getRVPPickupMetrics'))
        for (const key of keyLists) {
            const originalData = _api.getState().courierPerformanceApi.queries[key]?.originalArgs
            const isFulfilled = _api.getState().courierPerformanceApi.queries[key]?.status === 'fulfilled'

            const isSameFromDate = originalData.fromDate === queryParams.fromDate
            const isSameToDate = originalData.toDate === queryParams.toDate

            if (isFulfilled && isSameFromDate && isSameToDate) {
                this.dataList = _api.getState().courierPerformanceApi.queries[key]?.data || []
            }
        }
    }

    groupByCourierId(dataList) {
        return dataList.reduce((acc, item) => {
            const courierId = item.courierId;
            if (!acc.has(courierId)) {
                acc.set(courierId, []);
            }
            acc.get(courierId)?.push(item);
            return acc;
        }, new Map())
    }

    getSumByProperty(property, dataList) {
        return dataList.reduce((acc, item) => {
            return acc + ((item[property] || 0))
        }, 0);
    }

    calculatePercentage(numerator, denominator) {
        return numerator / denominator * 100 || 0;
    }

    dataGroupByDate() {
        return this.dataList.reduce((acc, item) => {
            const date = item.awbRegisteredDay;
            if (!acc.has(date)) {
                acc.set(date, []);
            }
            acc.get(date)?.push(item);
            return acc;
        }, new Map())
    }

    getPerformaceTrend() {
        const dataGroupByDate = this.dataGroupByDate();
        const dataMaPKeys = Array.from(dataGroupByDate.keys());

        const rvpPickupPerformanceTrend = []

        for (const index in this.interval.slice(0, -1)) {
            const start = this.interval[index]
            const end = this.interval[+index + 1] || start

            const dataWithInInterval = dataMaPKeys
                .filter((date) => isWithinInterval(new Date(date), { start, end }))
                .map((date) => dataGroupByDate.get(date) || [])
                .flat();

            rvpPickupPerformanceTrend.push({
                name: getChartName({ groupOn: this.groupOn, start, end }),
                data: this.getPerformace(dataWithInInterval),
            })
        }

        return rvpPickupPerformanceTrend;
    }

    getPerformaceSplit(dataList) {
        const totalRVPRequestCount = this.getSumByProperty('totalRVPRequestCount', dataList)
        const totalRVPPickedupCount = this.getSumByProperty('totalRVPPickedupCount', dataList)
        const pickedupInTATCount = this.getSumByProperty('pickedupInTATCount', dataList)
        const pickedupInTATPlusOneCount = pickedupInTATCount + this.getSumByProperty('pickedupInTATPlusOneCount', dataList)
        const pickedupInTATPlusTwoCount = pickedupInTATPlusOneCount + this.getSumByProperty('pickedupInTATPlusTwoCount', dataList)
        const pickedupInTATPlusThreeCount = pickedupInTATPlusTwoCount + this.getSumByProperty('pickedupInTATPlusThreeCount', dataList)



        return {
            rvpPickupAdherence: this.calculatePercentage(pickedupInTATCount, totalRVPRequestCount),
            rvpPickupPlusOneAdherence: this.calculatePercentage(pickedupInTATPlusOneCount, totalRVPRequestCount),
            rvpPickupPlusTwoAdherence: this.calculatePercentage(pickedupInTATPlusTwoCount, totalRVPRequestCount),
            rvpPickupPlusThreeAdherence: this.calculatePercentage(pickedupInTATPlusThreeCount, totalRVPRequestCount),
            totalRVPRequestCount,
            totalRVPPickedupCount,
            pickedupInTATCount,
            pickedupInTATPlusOneCount,
            pickedupInTATPlusTwoCount,
            pickedupInTATPlusThreeCount
        }
    }

    getPerformace(dataList) {
        const courierWiseData = this.groupByCourierId(dataList || this.dataList);
        return Array.from(courierWiseData.entries()).reduce((acc, [courierId, dataList]) => {
            acc.set(courierId, {
                courierId,
                ...this.getPerformaceSplit(dataList)
            })
            return acc;
        }, new Map())
    }
}
